// @flow

import axios      from 'axios';
import RoutesAPI  from './Routes';

let API_URL = '';
if( process.env.REACT_APP_API_URL ) {
  API_URL = process.env.REACT_APP_API_URL;
}

// Requests
const requests = {
  get: (url, body) => {
    return axios.get(API_URL + url, body);
  },

  put: (url: string, body: any, headers: any) => {
    return axios.put(API_URL + url, body);
  }
};

const UserAPI = {
  getUser: () => {
    return requests.get(RoutesAPI.user_get(), {});
  },

  getUserApplications: () => {
    return requests.get(RoutesAPI.user_applications(), {});
  },

  getPersonalInfo: () => {
    return requests.get(RoutesAPI.user_personal_info(), {});
  },

  setNotification: (params: Object) => {
    return requests.put(RoutesAPI.set_notification(), { setting: params });
  },

  sendDestroyAccountMail: () => {
    return requests.get(RoutesAPI.send_destroy_mail(), {})
  },

  getScopes: () => {
    return requests.get(RoutesAPI.get_scopes(), {})
  },

  setScope: (id: number) => {
    return requests.put(RoutesAPI.set_scope(id), {})
  }
}

export default UserAPI;



// WEBPACK FOOTER //
// ./src/api/UserAPI.js